import { Accordion } from '../../../../../components/general/accordion';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import dayjs from 'dayjs';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import { SurveyRegisterHistoryProps } from './props';
import { useSurveyRegisterHistory } from './hook';

export const SurveyRegisterHistory = ({
    survey,
}: SurveyRegisterHistoryProps) => {
    const { formik } = useSurveyRegisterHistory(survey);

    return (
        <Accordion
            title="REGISTRO"
            icon={<InsertInvitationIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Creado por"
                        name="createdBy"
                        size="small"
                        value={formik.values.createdBy}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DateTimePickerField
                        label="Fecha de creación"
                        name="createdAt"
                        size="small"
                        value={
                            survey?.created_at
                                ? dayjs(survey.created_at).subtract(5, 'h')
                                : null
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Modificado por"
                        name="updatedBy"
                        size="small"
                        value={formik.values.updatedBy}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DateTimePickerField
                        label="Fecha de modificación"
                        name="updatedAt"
                        size="small"
                        value={
                            survey?.updated_at
                                ? dayjs(survey.updated_at).subtract(5, 'h')
                                : null
                        }
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
